// @flow
import React from 'react';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import EventViewer from 'containers/event/EventViewer';
import { type Match } from 'react-router-dom';
import EventCommentsContainer from 'containers/event/EventCommentsContainer';
import EventSequencesContainer from 'containers/event/EventSequencesContainer';
import PlainTemplate from 'components/common/PlainTemplate';
import PageTemplate from 'components/base/PageTemplate';

type Props = {
  match: Match,
};

const Event = ({ match }: Props) => {
  const { username, urlSlug } = match.params;

  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <PlainTemplate>
        <EventViewer username={username} urlSlug={decodeURI(urlSlug || '')} />
        <EventCommentsContainer />
      </PlainTemplate>
      <EventSequencesContainer username={username || ''} />
      <MainMobileFooter />
    </PageTemplate>
  );
};

export default Event;



// WEBPACK FOOTER //
// ./src/pages/Event.js